/* ============================================================
   YOOME HEADER (yh-header) behaviour.
   The bag button keeps id="CartToggle" and the .cart-count class, and the
   mobile search button keeps id="SearchToggle", so yoome.js still opens the
   cart drawer, updates the count and opens the search sheet.
   ============================================================ */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia('(min-width: 990px)');

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function onChange(mq, fn) { if (mq.addEventListener) mq.addEventListener('change', fn); else mq.addListener(fn); }

  // ---- Sticky: only the menu band stays on desktop; on mobile the header
  // tucks away while scrolling down and comes back when scrolling up. ----
  function initSticky(header) {
    var section = header.closest('.shopify-section') || header.parentElement;
    var ann = header.querySelector('[data-yhh-ann]');
    var main = header.querySelector('[data-yhh-main]');
    var minis = $$('.yhh-nav__mini, .yhh-nav__mini-cart', header);
    var offset = 0;
    var lastY = window.scrollY;
    var queued = false;
    var stuck = null;

    function setStuck(next) {
      if (next === stuck) return;
      stuck = next;
      header.classList.toggle('is-stuck', next);
      minis.forEach(function (el) {
        if (next) { el.removeAttribute('aria-hidden'); el.removeAttribute('tabindex'); }
        else { el.setAttribute('aria-hidden', 'true'); el.setAttribute('tabindex', '-1'); }
      });
    }

    function update() {
      queued = false;
      var y = window.scrollY;
      setStuck(desktop.matches && y > offset + 2);
      if (!desktop.matches) {
        var busy = document.documentElement.classList.contains('yhh-lock') || header.querySelector('.is-open');
        if (y > lastY + 6 && y > offset + 160 && !busy) header.classList.add('is-tucked');
        else if (y < lastY - 6 || y <= offset + 10) header.classList.remove('is-tucked');
      } else {
        header.classList.remove('is-tucked');
      }
      lastY = y;
    }

    function measure() {
      var a = ann ? ann.offsetHeight : 0;
      offset = desktop.matches ? a + (main ? main.offsetHeight : 0) : a;
      section.style.setProperty('--yhh-offset', offset + 'px');
      update();
    }

    window.addEventListener('scroll', function () {
      if (!queued) { queued = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(header);
    else window.addEventListener('resize', measure);
    onChange(desktop, measure);
    measure();
  }

  // ---- Announcement messages slide up one after another ----
  function initRotator(header) {
    var box = header.querySelector('[data-yhh-rotator]');
    if (!box) return;
    var msgs = $$('.yhh-ann__msg', box);
    if (msgs.length < 2) return;
    var i = 0;
    var paused = false;
    var secs = parseFloat(getComputedStyle(header).getPropertyValue('--yhh-rotate')) || 5;

    function show(n) {
      var cur = msgs[i];
      i = (n + msgs.length) % msgs.length;
      if (cur === msgs[i]) return;
      cur.classList.remove('is-active');
      cur.classList.add('is-leaving');
      window.setTimeout(function () { cur.classList.remove('is-leaving'); }, 500);
      msgs[i].classList.add('is-active');
    }

    window.setInterval(function () { if (!paused && !document.hidden) show(i + 1); }, secs * 1000);
    box.addEventListener('mouseenter', function () { paused = true; });
    box.addEventListener('mouseleave', function () { paused = false; });
    box.addEventListener('focusin', function () { paused = true; });
    box.addEventListener('focusout', function () { paused = false; });
    header._yhhShowMsg = function (el) { var n = msgs.indexOf(el); if (n > -1) { paused = true; show(n); } };
  }

  // ---- "Open today 10am–5pm" from lines like "Mon–Wed: 10am–5pm" ----
  var DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  function isToday(dayText, today) {
    var text = dayText.toLowerCase();
    var range = text.split(/\s*[–—-]\s*|\s+to\s+/);
    if (range.length === 2) {
      var a = DAYS.indexOf(range[0].trim().slice(0, 3));
      var b = DAYS.indexOf(range[1].trim().slice(0, 3));
      if (a < 0 || b < 0) return false;
      for (var d = a; ; d = (d + 1) % 7) {
        if (d === today) return true;
        if (d === b) return false;
      }
    }
    return text.split(/\s*(?:,|&|and)\s*/).some(function (part) {
      return DAYS.indexOf(part.trim().slice(0, 3)) === today;
    });
  }
  function hoursToday(raw) {
    var today = new Date().getDay();
    var lines = String(raw).split(/<br\s*\/?>|\n/);
    for (var k = 0; k < lines.length; k++) {
      var line = lines[k];
      var cut = line.indexOf(':');
      if (cut < 0) continue;
      if (isToday(line.slice(0, cut), today)) return line.slice(cut + 1).trim();
    }
    return null;
  }
  function initToday() {
    $$('[data-yhh-today]').forEach(function (el) {
      var time = hoursToday(el.dataset.hours || '');
      if (!time) return;
      var slot = el.querySelector('[data-yhh-today-time]');
      if (/closed/i.test(time)) {
        var label = slot ? slot.parentNode : el;
        label.textContent = 'Closed today';
      } else if (slot) {
        slot.textContent = time;
      }
      el.hidden = false;
    });
  }

  // ---- The "oo" in the name follow the cursor and blink now and then ----
  function initEyes(header) {
    var pupils = $$('[data-yhh-eye] i', header);
    if (!pupils.length || reduced || window.matchMedia('(hover: none)').matches) return;
    var x = 0, y = 0, frame = null;

    function look() {
      frame = null;
      pupils.forEach(function (p) {
        var r = p.parentNode.getBoundingClientRect();
        if (r.bottom < 0) return;
        var cx = r.left + r.width / 2;
        var cy = r.top + r.height * 0.61;
        var dx = x - cx, dy = y - cy;
        var dist = Math.sqrt(dx * dx + dy * dy) || 1;
        var reach = r.width * 0.11 * Math.min(1, dist / 160);
        p.style.setProperty('--px', (dx / dist * reach).toFixed(2) + 'px');
        p.style.setProperty('--py', (dy / dist * reach * 0.85).toFixed(2) + 'px');
      });
    }
    window.addEventListener('pointermove', function (e) {
      x = e.clientX; y = e.clientY;
      if (!frame) frame = window.requestAnimationFrame(look);
    }, { passive: true });

    (function blink() {
      pupils.forEach(function (p) { p.style.setProperty('--blink', '0.1'); });
      window.setTimeout(function () { pupils.forEach(function (p) { p.style.setProperty('--blink', '1'); }); }, 140);
      window.setTimeout(blink, 2800 + Math.random() * 3600);
    })();
  }

  // ---- Search: typing placeholder, "/" shortcut, live results ----
  function formatPrice(amount) {
    var n = Number(amount);
    if (isNaN(n)) return '';
    var fmt = (window.Yoome && window.Yoome.moneyFormat) || '${{amount}}';
    var value = n.toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/, value);
  }
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function attachLive(input, out, searchUrl) {
    if (!input || !out) return;
    var timer = null;
    var ctrl = null;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function render(q, res) {
      var cols = (res.collections || []).slice(0, 3);
      var prods = (res.products || []).slice(0, 5);
      var html = '';
      if (cols.length) {
        html += '<div class="yhh-res-cols">' + cols.map(function (c) {
          return '<a class="yhh-chip" href="' + esc(c.url) + '">' + esc(c.title) + '</a>';
        }).join('') + '</div>';
      }
      html += prods.map(function (p) {
        return '<a class="yhh-res" href="' + esc(p.url) + '">' +
          '<span class="yhh-res__img">' + (p.image ? '<img src="' + esc(sized(p.image, 120)) + '" alt="" width="52" height="52" loading="lazy">' : '') + '</span>' +
          '<span class="yhh-res__title">' + esc(p.title) + '</span>' +
          '<span class="yhh-res__price">' + esc(formatPrice(p.price)) + '</span></a>';
      }).join('');
      if (!cols.length && !prods.length) {
        html = '<p class="yhh-res-empty">No matches for “' + esc(q) + '” yet. Try one of these:</p>';
      } else if (prods.length) {
        html += '<a class="yhh-res-all" href="' + esc(searchUrl) + '?q=' + encodeURIComponent(q) + '&amp;type=product">See all results for “' + esc(q) + '” →</a>';
      }
      out.innerHTML = html;
      out.classList.remove('is-loading');
    }

    function run(q) {
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      out.classList.add('is-loading');
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=5&resources[options][unavailable_products]=last';
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (data) {
          if (input.value.trim() !== q) return;
          render(q, (data.resources && data.resources.results) || {});
        })
        .catch(function (e) {
          if (e && e.name === 'AbortError') return;
          out.innerHTML = '';
          out.classList.remove('is-loading');
        });
    }

    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { if (ctrl) ctrl.abort(); out.innerHTML = ''; out.classList.remove('is-loading'); return; }
      timer = window.setTimeout(function () { run(q); }, 180);
    });
  }

  function typewriter(input) {
    var words = (input.dataset.yhhTypewriter || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!words.length || reduced) return;
    var base = 'Search for ';
    var w = 0, c = words[0].length, deleting = true;

    function tick() {
      if (document.hidden || document.activeElement === input || input.value) {
        window.setTimeout(tick, 700);
        return;
      }
      var word = words[w];
      if (deleting) {
        c -= 1;
        if (c <= 0) { deleting = false; w = (w + 1) % words.length; c = 0; }
      } else {
        c += 1;
        if (c >= word.length) {
          input.placeholder = base + word;
          deleting = true;
          window.setTimeout(tick, 1800);
          return;
        }
      }
      input.placeholder = base + words[w].slice(0, c);
      window.setTimeout(tick, deleting ? 35 : 80);
    }
    window.setTimeout(tick, 2200);
  }

  function initSearch(header) {
    var form = header.querySelector('[data-yhh-search]');
    if (form) {
      var input = form.querySelector('[data-yhh-input]');
      var closeTimer = null;
      function openPop() { window.clearTimeout(closeTimer); form.classList.add('is-open'); }
      form.addEventListener('focusin', openPop);
      input.addEventListener('click', openPop);
      input.addEventListener('input', openPop);
      form.addEventListener('focusout', function () {
        closeTimer = window.setTimeout(function () {
          if (!form.contains(document.activeElement)) form.classList.remove('is-open');
        }, 120);
      });
      form.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { form.classList.remove('is-open'); input.blur(); }
      });
      typewriter(input);
      if (input.hasAttribute('data-yhh-live')) attachLive(input, form.querySelector('[data-yhh-results]'), form.getAttribute('action'));

      document.addEventListener('keydown', function (e) {
        if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey || !desktop.matches) return;
        var t = e.target;
        if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
        e.preventDefault();
        input.focus();
      });
    }

    // Give the theme's mobile search sheet the same live results and popular chips.
    var sheet = document.getElementById('SearchDrawer');
    var sheetInput = document.getElementById('SearchInput');
    if (sheet && sheetInput && !sheet.querySelector('.yhh-sheet')) {
      var wrap = document.createElement('div');
      wrap.className = 'yhh-sheet';
      wrap.innerHTML = '<div class="yhh-pop__results" data-yhh-results aria-live="polite"></div>';
      var popular = header.querySelector('[data-yhh-popular]');
      if (popular) wrap.appendChild(popular.cloneNode(true));
      (sheet.querySelector('.search-drawer__inner') || sheet).appendChild(wrap);
      var sheetForm = sheetInput.closest('form');
      var liveInput = form && form.querySelector('[data-yhh-input]');
      if (liveInput && liveInput.hasAttribute('data-yhh-live')) {
        attachLive(sheetInput, wrap.querySelector('[data-yhh-results]'), sheetForm ? sheetForm.getAttribute('action') : '/search');
      }
    }
  }

  // ---- Mega menus: open on hover (with a little intent delay), click or ↓ ----
  function initMega(header) {
    var items = $$('[data-yhh-item]', header);
    var closeTimer = null;
    var openTimer = null;

    function trig(item) { return item.querySelector('[data-yhh-trigger]'); }
    function close(item) {
      item.classList.remove('is-open');
      var t = trig(item);
      if (t) t.setAttribute('aria-expanded', 'false');
    }
    function closeAll(except) { items.forEach(function (i) { if (i !== except) close(i); }); }
    function open(item) {
      if (!item.querySelector('[data-yhh-panel]')) return;
      window.clearTimeout(closeTimer);
      closeAll(item);
      item.classList.add('is-open');
      trig(item).setAttribute('aria-expanded', 'true');
    }
    function anyOpen() { return items.some(function (i) { return i.classList.contains('is-open'); }); }

    items.forEach(function (item) {
      var t = trig(item);
      item.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'touch') return;
        window.clearTimeout(closeTimer);
        window.clearTimeout(openTimer);
        if (!t) { closeTimer = window.setTimeout(closeAll, 120); return; }
        openTimer = window.setTimeout(function () { open(item); }, anyOpen() ? 0 : 90);
      });
      item.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'touch') return;
        window.clearTimeout(openTimer);
        if (t) closeTimer = window.setTimeout(function () { close(item); }, 180);
      });
      if (!t) return;
      t.addEventListener('click', function (e) {
        e.preventDefault();
        if (item.classList.contains('is-open')) close(item); else open(item);
      });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown') return;
        e.preventDefault();
        open(item);
        var first = item.querySelector('[data-yhh-panel] a');
        if (first) first.focus();
      });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close(item);
      });
    });

    document.addEventListener('click', function (e) { if (!header.contains(e.target)) closeAll(); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var opened = items.filter(function (i) { return i.classList.contains('is-open'); })[0];
      if (opened) { close(opened); trig(opened).focus(); }
    });

    header._yhhOpenItem = function (el) { var item = el.closest('[data-yhh-item]'); if (item) open(item); };
    header._yhhCloseAll = closeAll;
  }

  // ---- Mobile drawer ----
  function initDrawer(header) {
    var toggle = header.querySelector('#YhhMenuToggle');
    var drawer = document.getElementById('YhhDrawer');
    var overlay = document.getElementById('YhhOverlay');
    if (!toggle || !drawer) return;

    function set(open, returnFocus) {
      drawer.classList.toggle('is-open', open);
      if (overlay) overlay.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('yhh-lock', open);
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) {
        header.classList.remove('is-tucked');
        window.setTimeout(function () { var c = drawer.querySelector('[data-yhh-close]'); if (c) c.focus(); }, 60);
      } else if (returnFocus) {
        toggle.focus();
      }
    }

    toggle.addEventListener('click', function () { set(true); });
    $$('[data-yhh-close]', drawer).forEach(function (b) { b.addEventListener('click', function () { set(false, true); }); });
    if (overlay) overlay.addEventListener('click', function () { set(false, true); });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a')) set(false);
    });
    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('is-open')) return;
      if (e.key === 'Escape') { set(false, true); return; }
      if (e.key !== 'Tab') return;
      var focusable = $$('a[href], button:not([disabled]), input, summary', drawer).filter(function (el) { return el.offsetParent !== null; });
      if (!focusable.length) return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    header._yhhSetDrawer = set;
  }

  // ---- Bag: extra bag buttons open the same drawer; the count bounces ----
  function initCart(header) {
    $$('[data-yhh-cart-proxy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (header._yhhSetDrawer) header._yhhSetDrawer(false);
        var main = document.getElementById('CartToggle');
        if (main) main.click();
      });
    });

    var source = document.getElementById('CartCount');
    if (!source || !('MutationObserver' in window)) return;
    var last = source.textContent.trim();
    new MutationObserver(function () {
      var now = source.textContent.trim();
      $$('.cart-count-text').forEach(function (t) { t.textContent = now; });
      if (now === last) return;
      if (Number(now) > Number(last)) {
        $$('.yhh-count').forEach(function (c) {
          c.classList.remove('is-bump');
          void c.offsetWidth;
          c.classList.add('is-bump');
        });
      }
      last = now;
    }).observe(source, { childList: true, characterData: true, subtree: true });
  }

  function init(root) {
    var header = (root && root.matches && root.matches('[data-yhh-header]')) ? root : (root || document).querySelector('[data-yhh-header]');
    if (!header || header.dataset.yhhReady === 'true') return;
    header.dataset.yhhReady = 'true';
    initSticky(header);
    initRotator(header);
    initToday();
    initEyes(header);
    initSearch(header);
    initMega(header);
    initDrawer(header);
    initCart(header);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  // ---- Theme editor ----
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var header = e.target.closest && e.target.closest('[data-yhh-header]');
    if (!header) return;
    if (e.target.classList.contains('yhh-ann__msg') && header._yhhShowMsg) header._yhhShowMsg(e.target);
    else if (header._yhhOpenItem) header._yhhOpenItem(e.target);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var header = e.target.closest && e.target.closest('[data-yhh-header]');
    if (header && header._yhhCloseAll) header._yhhCloseAll();
  });
})();
